"use client";
import React from 'react';
import { motion } from 'framer-motion';

export default function CrescentMoon({
  size = 60,
  color = '#C9A84C',
  animate = true,
  delay = 0,
}) {
  const r = size / 2;
  const circumference = 2 * Math.PI * r * 0.7;
  const maskId = `crescent-${size}-${color.replace('#','')}-${Math.random().toString(36).slice(2,7)}`;
  return (
    <svg width={size * 1.2} height={size} viewBox={`0 0 ${size * 1.2} ${size}`}>
      <defs>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="white" />
          <circle cx={size * 0.55} cy={size * 0.42} r={r * 0.72} fill="black" />
        </mask>
      </defs>
      <motion.circle
        cx={size * 0.5}
        cy={r}
        r={r * 0.88}
        fill={color}
        opacity={0.95}
        mask={`url(#${maskId})`}
        strokeDasharray={circumference}
        initial={animate ? { strokeDashoffset: circumference, opacity: 0 } : false}
        animate={animate ? { strokeDashoffset: 0, opacity: 0.95 } : false}
        transition={{ duration: 1.4, delay, ease: [0.76, 0, 0.24, 1] }}
      />
      <motion.polygon
        points={Array.from({ length: 10 }, (_, i) => {
          const a = (i * Math.PI) / 5 - Math.PI / 2;
          const rad = i % 2 === 0 ? size * 0.08 : size * 0.04;
          const cx = size * 0.92;
          const cy = size * 0.22;
          return `${cx + rad * Math.cos(a)},${cy + rad * Math.sin(a)}`;
        }).join(' ')}
        fill={color}
        initial={animate ? { opacity: 0, scale: 0 } : false}
        animate={animate ? { opacity: 1, scale: 1 } : false}
        transition={{ delay: delay + 1.2, duration: 0.4, ease: [0.34, 1.56, 0.64, 1] }}
      />
    </svg>
  );
}
